import axios from 'axios';
import {
  GET_TOTAL_FEEDBACKS,
  GET_TOTAL_CUSTOMER,
  GET_TOTAL_LOYALITY,
  GET_TOTAL_CAMPAIGN,
  GET_TOTAL_REFFERALS,
  GET_TOTAL_NEGATVIE_FEEDBACK,
  GET_UPCOMING_EVENTS,
  GET_WEIGHTED_GRAPH,
  GET_NON_WEIGHTED_GRAPH,
  GET_FEEDBACK_FORM_TYPE,
  GET_SATISFACTION_SCORE,
  GET_RETENTION_SCORE,
  GET_CLIENT_SUBSCRIPTION_STATUS,
  GET_TOTAL_RESPONSES_WIDGET,
  GET_CSAT_WIDGET,
  GET_NPS_WIDGET,
  GET_AT_RISK_WIDGET,
  GET_SENTIMENT_MIX_WIDGET,
  GET_TICKET_SUMMARY_WIDGET,
  GET_RECENT_NEGATIVE_COMMENTS_WIDGET,
  GET_LOCATION_COMPARISON_WIDGET,
  GET_NEGATIVE_THEMES_WIDGET,
  GET_COMPLAINT_CATEGORIES_WIDGET,
  GET_NPS_TREND_WIDGET,
  GET_SATISFACTION_TREND_WIDGET,
} from '../constants/dashboard'

const DASHBOARD_BASE_URL = `${process.env.REACT_APP_API_URL}/dashboard`
// const DASHBOARD_BASE_URL = `${process.env.REACT_APP_API_URL}/dashboard`

/**
 * Filter data according to the range 
 * have to hit all api with "start" and "end" params 
 * @param {* start_data from range picker} start 
 * @param {* end_date from range picker} end 
 * @returns filtered data
 * 
 */

export const filterDataByRange = (start, end) => async (dispatch, getState) => {
  let token = getState().auth.token;
  if(token && start && end){
    dispatch(fetchTotalFeedbacks(start, end))
    dispatch(fetchTotalCustomers(start, end))
    dispatch(fetchTotalLoyality(start, end))
    dispatch(fetchTotalCampaign(start, end))
    dispatch(fetchTotalRefferal(start, end))
    dispatch(fetchTotalNegativeFeedback(start, end))
    dispatch(fetchUpcomingEvents(start, end))
    dispatch(fetchSatisfactionChartScore(start, end))
    dispatch(fetchRetentionChartScore(start, end))
    dispatch(fetchTotalResponsesWidget(start, end))
    dispatch(fetchCsatWidget(start, end))
    dispatch(fetchNpsWidget(start, end))
    dispatch(fetchAtRiskWidget(start, end))
    dispatch(fetchSentimentMixWidget(start, end))
    dispatch(fetchTicketSummaryWidget(start, end))
    dispatch(fetchRecentNegativeCommentsWidget(start, end))
    dispatch(fetchLocationComparisonWidget(start, end))
    dispatch(fetchNegativeThemesWidget(start, end))
    dispatch(fetchComplaintCategoriesWidget(start, end))
    dispatch(fetchNpsTrendWidget(start, end))
    dispatch(fetchSatisfactionTrendWidget(start, end))
  }
}

/**
 * On range picker clear 
 * @returns last 30 days data by default 
 */

export const onRangeClear = () => async (dispatch, getState) => {
  let token = getState().auth.token;
  if(token){
    dispatch(fetchTotalFeedbacks())
    dispatch(fetchTotalCustomers())
    dispatch(fetchTotalLoyality())
    dispatch(fetchTotalCampaign())
    dispatch(fetchTotalRefferal())
    dispatch(fetchTotalNegativeFeedback())
    dispatch(fetchUpcomingEvents())
    dispatch(fetchSatisfactionChartScore())
    dispatch(fetchRetentionChartScore())
    dispatch(fetchTotalResponsesWidget())
    dispatch(fetchCsatWidget())
    dispatch(fetchNpsWidget())
    dispatch(fetchAtRiskWidget())
    dispatch(fetchSentimentMixWidget())
    dispatch(fetchTicketSummaryWidget())
    dispatch(fetchRecentNegativeCommentsWidget())
    dispatch(fetchLocationComparisonWidget())
    dispatch(fetchNegativeThemesWidget())
    dispatch(fetchComplaintCategoriesWidget())
    dispatch(fetchNpsTrendWidget())
    dispatch(fetchSatisfactionTrendWidget())
  }
}

export const fetchTotalFeedbacks = (start, end) => async (dispatch, getState) => {
  let token = getState().auth.token;
  let headers = { 'Content-Type': 'application/json' }
  if(token){
    headers['Authorization'] = `Token ${token}`;
    try {
      let response = await axios.get(
        `${DASHBOARD_BASE_URL}/apiv2/all-feedback/${start && end ? `?start=${start}&end=${end}` :''}`,
        { headers }
      )
      
      if(response.status === 200){
        dispatch({ type: GET_TOTAL_FEEDBACKS, data: response.data.data })
        
      }

    } catch(err) {
      throw err
    }
  }
}

export const fetchTotalCustomers = (start, end) => async (dispatch, getState) => {
  let token = getState().auth.token;
  let headers = { 'Content-Type': 'application/json' }
  if(token){
    headers['Authorization'] = `Token ${token}`;
    try {
      let response = await axios.get(
        `${DASHBOARD_BASE_URL}/apiv2/all-customer/${start && end ? `?start=${start}&end=${end}` :''}`,
        { headers }
      )
      
      if(response.status === 200){
        dispatch({ type: GET_TOTAL_CUSTOMER, data: response.data.data })
      }

    } catch(err) {
      throw err
    }
  }
}

export const fetchTotalLoyality = (start, end) => async (dispatch, getState) => {
  let token = getState().auth.token;
  let headers = { 'Content-Type': 'application/json' }
  if(token){
    headers['Authorization'] = `Token ${token}`;
    try {
      let response = await axios.get(
        `${DASHBOARD_BASE_URL}/apiv2/all-loyalty/${start && end ? `?start=${start}&end=${end}` :''}`,
        { headers }
      )
      
      if(response.status === 200){
        dispatch({ type: GET_TOTAL_LOYALITY, data: response.data.data })
      }

    } catch(err) {
      throw err
    }
  }
}

export const fetchTotalCampaign = (start, end) => async (dispatch, getState) => {
  let token = getState().auth.token;
  let headers = { 'Content-Type': 'application/json' }
  if(token){
    headers['Authorization'] = `Token ${token}`;
    try {
      let response = await axios.get(
        `${DASHBOARD_BASE_URL}/apiv2/all-campaign/${start && end ? `?start=${start}&end=${end}` :''}`,
        { headers }
      )
      
      if(response.status === 200){
        dispatch({ type: GET_TOTAL_CAMPAIGN, data: response.data.data })
      }

    } catch(err) {
      throw err
    }
  }
}

export const fetchTotalRefferal = (start, end) => async (dispatch, getState) => {
  let token = getState().auth.token;
  let headers = { 'Content-Type': 'application/json' }
  if(token){
    headers['Authorization'] = `Token ${token}`;
    try {
      let response = await axios.get(
        `${DASHBOARD_BASE_URL}/apiv2/all-refferal/${start && end ? `?start=${start}&end=${end}` :''}`,
        { headers }
      )
      
      if(response.status === 200){
        dispatch({ type: GET_TOTAL_REFFERALS, data: response.data.data })
      }

    } catch(err) {
      throw err
    }
  }
}

export const fetchTotalNegativeFeedback = (start, end) => async (dispatch, getState) => {
  let token = getState().auth.token;
  let headers = { 'Content-Type': 'application/json' }
  if(token){
    headers['Authorization'] = `Token ${token}`;
    try {
      let response = await axios.get(
        `${DASHBOARD_BASE_URL}/apiv2/all-negative-feedback/${start && end ? `?start=${start}&end=${end}` :''}`,
        { headers }
      )
      
      if(response.status === 200){
        dispatch({ type: GET_TOTAL_NEGATVIE_FEEDBACK, data: response.data.data })
      }

    } catch(err) {
      throw err
    }
  }
}

export const fetchUpcomingEvents = (start, end) => async (dispatch, getState) => {
  let token = getState().auth.token;
  let headers = { 'Content-Type': 'application/json' }
  if(token){
    headers['Authorization'] = `Token ${token}`;
    try {
      let response = await axios.get(
        `${DASHBOARD_BASE_URL}/apiv2/all-upcoming-events/${start && end ? `?start=${start}&end=${end}` :''}`,
        { headers }
      )
      
      if(response.status === 200){
        dispatch({ type: GET_UPCOMING_EVENTS, data: response.data.data })
      }

    } catch(err) {
      throw err
    }
  }
}

export const fetchFromType = () => async (dispatch, getState) => {
  let token = getState().auth.token;
  let headers = { 'Content-Type': 'application/json' }
  if(token){
    headers['Authorization'] = `Token ${token}`;
    try {
      let response = await axios.get(
        `${process.env.REACT_APP_API_URL}/feedbacks/apiv2/store/feedback-forms/?paginate=false`,
        { headers }
      )
      
      if(response.status === 200){
        dispatch({ type: GET_FEEDBACK_FORM_TYPE, data: response.data})
      }

    } catch(err) {
      throw err
    }
  }
}

export const fetchWeightedGraph = (data) => async (dispatch, getState) => {
  let token = getState().auth.token;
  let headers = { 'Content-Type': 'application/json' }
  if(token){
    headers['Authorization'] = `Token ${token}`;
    try {
      let response = await axios.get(
        `${DASHBOARD_BASE_URL}/apiv2/weighted-analysis/?feedback_form=${data}`,
        { headers }
      )
      
      if(response.status === 200){
        dispatch({ type: GET_WEIGHTED_GRAPH, data: response.data})
      }

    } catch(err) {
      throw err
    }
  }
}

export const fetchNonWeightedGraph = (data) => async (dispatch, getState) => {
  let token = getState().auth.token;
  let headers = { 'Content-Type': 'application/json' }
  if(token){
    headers['Authorization'] = `Token ${token}`;
    try {
      let response = await axios.get(
        `${DASHBOARD_BASE_URL}/apiv2/non-weighted-analysis/?feedback_form=${data}`,
        { headers }
      )
      
      if(response.status === 200){
        dispatch({ type: GET_NON_WEIGHTED_GRAPH, data: response.data.data})
      }

    } catch(err) {
      throw err
    }
  }
}

export const fetchSatisfactionChartScore = (start, end) => async (dispatch, getState) => {
  let token = getState().auth.token;
  let headers = { 'Content-Type': 'application/json' }
  if(token){
    headers['Authorization'] = `Token ${token}`;
    try {
      let response = await axios.get(
        `${DASHBOARD_BASE_URL}/apiv2/customer-satisfaction-score/${start && end ? `?start=${start}&end=${end}` :''}`,
        { headers }
      )
      
      if(response.status === 200){
        dispatch({ type: GET_SATISFACTION_SCORE, data: response.data.data })
      }

    } catch(err) {
      throw err
    }
  }
}

export const fetchRetentionChartScore = (start, end) => async (dispatch, getState) => {
  let token = getState().auth.token;
  let headers = { 'Content-Type': 'application/json' }
  if(token){
    headers['Authorization'] = `Token ${token}`;
    try {
      let response = await axios.get(
        `${DASHBOARD_BASE_URL}/apiv2/retention-score/${start && end ? `?start=${start}&end=${end}` :''}`,
        { headers }
      )
      
      if(response.status === 200){
        dispatch({ type: GET_RETENTION_SCORE, data: response.data.data })
      }

    } catch(err) {
      throw err
    }
  }
}

export const fetchClientSubscriptionStatus = () => async (dispatch, getState) => {
  let token = getState().auth.token;

  let headers = {
    'Content-Type': 'application/json',
    'Authorization': `Token ${token}`
  };

  try {
    const response = await axios.get(
      `${DASHBOARD_BASE_URL}/apiv2/client-subscription-status/`,
      { headers }
    );

    dispatch({
      type: GET_CLIENT_SUBSCRIPTION_STATUS,
      data: response.data.data
    });

  } catch (err) {
    console.error(err);
  }
};

export const fetchTotalResponsesWidget = (start, end) => async (dispatch, getState) => {
  let token = getState().auth.token;
  let headers = { 'Content-Type': 'application/json' }
  if(token){
    headers['Authorization'] = `Token ${token}`;
    try {
      let response = await axios.get(
        `${DASHBOARD_BASE_URL}/apiv2/widgets/total-responses/${start && end ? `?start_date=${start}&end_date=${end}` :''}`,
        { headers }
      )

      if(response.status === 200){
        dispatch({ type: GET_TOTAL_RESPONSES_WIDGET, data: { ...response.data.data, period: response.data.period } })
      }

    } catch(err) {
      throw err
    }
  }
}

export const fetchCsatWidget = (start, end) => async (dispatch, getState) => {
  let token = getState().auth.token;
  let headers = { 'Content-Type': 'application/json' }
  if(token){
    headers['Authorization'] = `Token ${token}`;
    try {
      let response = await axios.get(
        `${DASHBOARD_BASE_URL}/apiv2/widgets/csat/${start && end ? `?start_date=${start}&end_date=${end}` :''}`,
        { headers }
      )

      if(response.status === 200){
        dispatch({ type: GET_CSAT_WIDGET, data: response.data.data })
      }

    } catch(err) {
      throw err
    }
  }
}

export const fetchNpsWidget = (start, end) => async (dispatch, getState) => {
  let token = getState().auth.token;
  let headers = { 'Content-Type': 'application/json' }
  if(token){
    headers['Authorization'] = `Token ${token}`;
    try {
      let response = await axios.get(
        `${DASHBOARD_BASE_URL}/apiv2/widgets/nps/${start && end ? `?start_date=${start}&end_date=${end}` :''}`,
        { headers }
      )

      if(response.status === 200){
        dispatch({ type: GET_NPS_WIDGET, data: response.data.data })
      }

    } catch(err) {
      throw err
    }
  }
}

export const fetchAtRiskWidget = (start, end) => async (dispatch, getState) => {
  let token = getState().auth.token;
  let headers = { 'Content-Type': 'application/json' }
  if(token){
    headers['Authorization'] = `Token ${token}`;
    try {
      let response = await axios.get(
        `${DASHBOARD_BASE_URL}/apiv2/widgets/at-risk/${start && end ? `?start_date=${start}&end_date=${end}` :''}`,
        { headers }
      )

      if(response.status === 200){
        dispatch({ type: GET_AT_RISK_WIDGET, data: { ...response.data.data, period: response.data.period } })
      }

    } catch(err) {
      throw err
    }
  }
}

export const fetchSentimentMixWidget = (start, end) => async (dispatch, getState) => {
  let token = getState().auth.token;
  let headers = { 'Content-Type': 'application/json' }
  if(token){
    headers['Authorization'] = `Token ${token}`;
    try {
      let response = await axios.get(
        `${DASHBOARD_BASE_URL}/apiv2/widgets/sentiment-mix/${start && end ? `?start_date=${start}&end_date=${end}` :''}`,
        { headers }
      )

      if(response.status === 200){
        dispatch({ type: GET_SENTIMENT_MIX_WIDGET, data: response.data.data })
      }

    } catch(err) {
      throw err
    }
  }
}

export const fetchTicketSummaryWidget = (start, end) => async (dispatch, getState) => {
  let token = getState().auth.token;
  let headers = { 'Content-Type': 'application/json' }
  if(token){
    headers['Authorization'] = `Token ${token}`;
    try {
      let response = await axios.get(
        `${DASHBOARD_BASE_URL}/apiv2/widgets/ticket-summary/${start && end ? `?start_date=${start}&end_date=${end}` :''}`,
        { headers }
      )

      if(response.status === 200){
        dispatch({ type: GET_TICKET_SUMMARY_WIDGET, data: response.data.data })
      }

    } catch(err) {
      throw err
    }
  }
}

export const fetchRecentNegativeCommentsWidget = (start, end) => async (dispatch, getState) => {
  let token = getState().auth.token;
  let headers = { 'Content-Type': 'application/json' }
  if(token){
    headers['Authorization'] = `Token ${token}`;
    try {
      let response = await axios.get(
        `${DASHBOARD_BASE_URL}/apiv2/widgets/recent-negative-comments/${start && end ? `?start_date=${start}&end_date=${end}` :''}`,
        { headers }
      )

      if(response.status === 200){
        dispatch({ type: GET_RECENT_NEGATIVE_COMMENTS_WIDGET, data: response.data.data })
      }

    } catch(err) {
      throw err
    }
  }
}

export const fetchLocationComparisonWidget = (start, end) => async (dispatch, getState) => {
  let token = getState().auth.token;
  let headers = { 'Content-Type': 'application/json' }
  if(token){
    headers['Authorization'] = `Token ${token}`;
    try {
      let response = await axios.get(
        `${DASHBOARD_BASE_URL}/apiv2/widgets/location-comparison/${start && end ? `?start_date=${start}&end_date=${end}` :''}`,
        { headers }
      )

      if(response.status === 200){
        dispatch({ type: GET_LOCATION_COMPARISON_WIDGET, data: response.data.data })
      }

    } catch(err) {
      throw err
    }
  }
}

export const fetchNegativeThemesWidget = (start, end) => async (dispatch, getState) => {
  let token = getState().auth.token;
  let headers = { 'Content-Type': 'application/json' }
  if(token){
    headers['Authorization'] = `Token ${token}`;
    try {
      let response = await axios.get(
        `${DASHBOARD_BASE_URL}/apiv2/widgets/negative-themes/${start && end ? `?start_date=${start}&end_date=${end}` :''}`,
        { headers }
      )

      if(response.status === 200){
        dispatch({ type: GET_NEGATIVE_THEMES_WIDGET, data: response.data.data })
      }

    } catch(err) {
      throw err
    }
  }
}

export const fetchComplaintCategoriesWidget = (start, end) => async (dispatch, getState) => {
  let token = getState().auth.token;
  let headers = { 'Content-Type': 'application/json' }
  if(token){
    headers['Authorization'] = `Token ${token}`;
    try {
      let response = await axios.get(
        `${DASHBOARD_BASE_URL}/apiv2/widgets/complaint-categories/${start && end ? `?start_date=${start}&end_date=${end}` :''}`,
        { headers }
      )

      if(response.status === 200){
        dispatch({ type: GET_COMPLAINT_CATEGORIES_WIDGET, data: response.data.data })
      }

    } catch(err) {
      throw err
    }
  }
}

export const fetchNpsTrendWidget = (start, end, granularity, periods) => async (dispatch, getState) => {
  let token = getState().auth.token;
  let headers = { 'Content-Type': 'application/json' }
  if(token){
    headers['Authorization'] = `Token ${token}`;
    try {
      let params = {}
      if(start && end){
        params.start_date = start
        params.end_date = end
      }
      if(granularity){
        params.granularity = granularity
        if(periods){
          params[granularity === 'year' ? 'years' : 'months'] = periods
        }
      }
      let query = new URLSearchParams(params).toString()
      let response = await axios.get(
        `${DASHBOARD_BASE_URL}/apiv2/widgets/nps-trend/${query ? `?${query}` : ''}`,
        { headers }
      )

      if(response.status === 200){
        dispatch({ type: GET_NPS_TREND_WIDGET, data: response.data.data })
      }

    } catch(err) {
      throw err
    }
  }
}

export const fetchSatisfactionTrendWidget = (start, end) => async (dispatch, getState) => {
  let token = getState().auth.token;
  let headers = { 'Content-Type': 'application/json' }
  if(token){
    headers['Authorization'] = `Token ${token}`;
    try {
      let response = await axios.get(
        `${DASHBOARD_BASE_URL}/apiv2/widgets/satisfaction-trend/${start && end ? `?start_date=${start}&end_date=${end}` :''}`,
        { headers }
      )

      if(response.status === 200){
        dispatch({ type: GET_SATISFACTION_TREND_WIDGET, data: response.data.data })
      }

    } catch(err) {
      throw err
    }
  }
}